import React from 'react'
import '../../Explorer/dox_explorer.scss'
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook'
import DoxLargeCheckMark from '../graphics/doxLargeCheckmark'

const DoxUploadSuccessMessage = () => {
    const translateString = useTranslationContext()

    return (
        <div className='doxe-msg-outer'>
            <div className='dox-upload-success-msg'>
                <DoxLargeCheckMark />
                <div className='upload-sucess-message'>{translateString('Dox.DocumentUploader.Success')}</div>
            </div>
        </div>
    )
}

export default DoxUploadSuccessMessage;